<template>
  <div
    style="position: absolute; bottom: 0;left: 0;width: 160pt;height: 120pt;background: #1B1C1D;
    z-index: 10000;border-top-right-radius: 25px;display: flex;
    align-items: center; justify-content: center">
    <div style="width: 1px;height: 120pt;background-color: #565555;position: absolute; bottom: 0;left: 0;"></div>
    <button class="circular ui violet icon button" style="position: absolute; top: 10px; left: 20px;padding: 5px"
            v-on:click="onNowTimeButtonClick">
      <i class="clock outline icon"></i>
    </button>
    <div style="display: inline-block">
      <div style="cursor: pointer" v-on:click="onClockClick()" ref="dateTimePickerButton">
        <h3 class="ui header" style="margin: 0;text-align: center;color: #808080">
          {{time}}</h3>
        <h4 class="ui header" style="margin: 0;text-align: center;color: #808080">
          {{date}}</h4>
      </div>
      <div style=" visibility: hidden;height: 0">
        <input ref="dateTimePickerInput"/>
      </div>
      <div style="display: flex;  align-items: center; justify-content: center; width: 100%;margin-top: 5px">
        <div class="ui icon buttons">
          <button class="ui button" v-on:click="onClick('backward')" v-bind:class="backwardButtonClass"><i
            class="backward icon"></i></button>
          <button class="ui button" v-on:click="onClick('pause')" v-bind:class="pauseButtonClass"><i
            class="pause icon"></i>
          </button>
          <button class="ui button" v-on:click="onClick('play')" v-bind:class="playButtonClass"><i
            class="play icon"></i>
          </button>
          <button class="ui button" v-on:click="onClick('forward')" v-bind:class="forwardButtonClass"><i
            class="forward icon"></i></button>
        </div>
      </div>
      <vue-slider style="margin-top: 5px" v-model="timeMultiplierSliderValue"
                  v-bind="sliderOptions"></vue-slider>

      <h4 class="ui header" style="text-align: center;margin: 0;color: #808080">
        x{{timeMultiplierSliderValue}}</h4>

    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import moment from 'moment'
  import VueSlider from 'vue-slider-component'

  import Flatpickr from 'flatpickr'
  import 'flatpickr/dist/themes/dark.css'
  import FlatpickrRu from 'flatpickr/dist/l10n/ru.js'

  Flatpickr.localize(FlatpickrRu.ru);

  moment.locale('ru');

  export default {
    name: "clock-widget",
    props: {
      initTime: {
        type: Number,
        default: new Date().getTime()
      },
      cesiumObject: {
        type: String,
        default: 'default'
      }
    },
    data() {
      return {
        currentTime: this.initTime,
        timeMultiplierSliderValue: 1,
        currentButton: 'play',
        sliderOptions: {
          eventType: 'auto',
          width: 'auto',
          dotHeight: null,
          dotWidth: null,
          min: 1,
          max: 1000,
          interval: 1,
          show: true,
          speed: 0.5,
          tooltip: false
        }
      }
    },

    mounted() {
      this.$bus.$on('clockTick', e => {
        const time = e.currentTime;
        const d = time - this.currentTime;
        if (!d) return;
        this.currentTime = time;
      });

      this.setMultiplierVal(1);
    },

    computed: {
      time: function () {
        return moment(this.currentTime).format('LTS')
      },
      date: function () {
        return moment(this.currentTime).format('LL')
      },
      backwardButtonClass() {
        return this.currentButton === 'backward' ? 'violet' : ''
      },
      pauseButtonClass() {
        return this.currentButton === 'pause' ? 'violet' : ''
      },
      playButtonClass() {
        return this.currentButton === 'play' ? 'violet' : ''
      },
      forwardButtonClass() {
        return this.currentButton === 'forward' ? 'violet' : ''
      }
    },

    methods: {
      onClick(e) {
        if (e === 'play') this.timeMultiplierSliderValue = 1;
        if ((e === 'backward' || e === 'forward') && (this.currentButton === 'play' || this.timeMultiplierSliderValue === 1)) this.timeMultiplierSliderValue = 10;

        if ((this.currentButton === 'backward' || this.currentButton === 'pause') && e === 'forward') this.$emit("multiplierChanged", this.timeMultiplierSliderValue);
        else if ((this.currentButton === 'forward' || this.currentButton === 'pause') && e === 'backward') this.$emit("multiplierChanged", -this.timeMultiplierSliderValue);
        else if (e === 'pause') this.$emit("multiplierChanged", 0);
        else if (this.currentButton === 'pause') this.$emit("multiplierChanged", this.timeMultiplierSliderValue);

        this.currentButton = e;
      },
      onNowTimeButtonClick() {
        this.$emit("currentTimeChanged", new Date().getTime());
        this.currentButton = 'play';
        this.timeMultiplierSliderValue = 1;
      },

      getViewer() {
        return window.cesiumViewer[this.cesiumObject].viewer;
      },

      setMultiplierVal(val) {
        if (val > 1 && this.currentButton === 'play') this.currentButton = 'forward';
        if (val === 1 && this.currentButton === 'forward') this.currentButton = 'play';

        let multiplier = val;
        if (this.currentButton === 'backward') multiplier = -multiplier;
        else if (this.currentButton === 'pause') multiplier = 0;

        this.$emit("multiplierChanged", multiplier);
      },

      onClockClick() {
        this.openFlatpickr(this.$refs.dateTimePickerInput);
      },
      openFlatpickr(elem) {
        const self = this;

        this._flatpickr = new Flatpickr(elem, {
          dateFormat: 'lll',
          formatDate: (dateObj, fmt, defaultStr) => {
            if (dateObj) return moment(dateObj).format(fmt);
            return defaultStr || '';
          },
          defaultDate: self.currentTime,
          enableTime: true,
          time_24hr: true,
          enableSeconds: true,
          onChange: () => {
            self.$emit("currentTimeChanged", (+moment(elem.value, 'lll', true)));
          }
        });

        this._flatpickr.open();
      },
    },

    components: {VueSlider},

    watch: {
      timeMultiplierSliderValue(val, oldVal) {
        this.setMultiplierVal(val);
      }
    }
  }
</script>

<style>
  .flatpickr-day.selected {
    background: #6435C9 !important;
    border-color: #6435C9 !important;
  }

  .flatpickr-calendar {
    background-color: #1B1C1D !important;
  }

  .flatpickr-weekday {
    color: whitesmoke !important;
  }

  .vue-slider-process {
    background-color: #6435C9 !important;
  }
</style>
